import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { getApplicationStatus } from '../../services/driverService';

export default function DriverApplicationStatus() {
  const { currentUser } = useAuth();
  const [application, setApplication] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!currentUser) return;
    getApplicationStatus(currentUser.uid)
      .then(setApplication)
      .catch(console.error)
      .finally(() => setLoading(false));
  }, [currentUser]);

  if (loading) return <div className="flex justify-center p-20"><div className="spinner spinner-lg" /></div>;

  const statusConfig = {
    pending: { icon: '⏳', label: 'Pending', color: '#fbbf24', message: 'Your application has been received.' },
    documentsSubmitted: { icon: '📋', label: 'Documents Submitted', color: '#6366f1', message: 'Your documents are being reviewed.' },
    underReview: { icon: '🔍', label: 'Under Review', color: '#6366f1', message: 'An admin is reviewing your application.' },
    approved: { icon: '✅', label: 'Approved', color: '#2dd4a8', message: 'Congratulations! Complete your training to start driving.' },
    rejected: { icon: '❌', label: 'Rejected', color: '#ff6b6b', message: 'Your application was not approved.' },
    changesRequested: { icon: '✏️', label: 'Changes Requested', color: '#fbbf24', message: 'Please update your application.' },
  };

  const status = statusConfig[application?.status] || statusConfig.pending;

  return (
    <div className="max-w-[500px] mx-auto px-6 py-8 text-center">
      <Link to="/" className="text-brand-primary font-semibold text-[0.9rem] mb-8 block">← Home</Link>
      <div className="text-[4rem] mb-6">{status.icon}</div>
      <h1 className="font-serif text-[1.8rem] mb-2">Application Status</h1>
      <span className="badge mb-6 inline-block" style={{ background: `${status.color}20`, color: status.color }}>{status.label}</span>
      <p className="text-body leading-relaxed mb-8">{status.message}</p>
      {application?.status === 'changesRequested' && (
        <Link to="/driver/update-application" className="btn btn-primary inline-block mb-6">Update my application</Link>
      )}
      <p className="text-muted text-[0.85rem]">
        Submitted: {application?.submittedAt?.toDate?.()?.toLocaleDateString() || '—'}
      </p>
    </div>
  );
}